export default "__VITE_ASSET__fc3d0178__"